import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import GlobalFilterPanel, { FILTER_PERIOD_GROUP, FIELDS as GlobalFilterPanelFields } from '../../filter/GlobalFilterPanel';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import DataMiningCommonFilterPanel from '../DataMiningCommonFilterPanel';
import Logger, { LOG_LEVELS } from '../../../utils/log';

const log = new Logger('DATA_MINING_DELETE_LOG_FILTER_PANEL', LOG_LEVELS.DEBUG);
const DEFAULT_FILTER_SETTING = {
    hideElements: {
        month: true,
        year: true,
        countryCode: true,
        returnType: true,
        returnStatus: true
    },
    fieldOptions: {},
    filterPeriodGroup: FILTER_PERIOD_GROUP.DATE_RANGE,
    adaptPeriodOptions: {
        customDateRangeProvider: (selection) => {
            let customDateRange = {};
            let selectionEndDate = selection.endDate ? moment.utc(selection.endDate) : moment.utc(new Date());
            customDateRange.endDate = selectionEndDate;
            customDateRange.startDate = moment.utc(selectionEndDate).subtract('1', 'month');
            return customDateRange;
        }
    }
};
DEFAULT_FILTER_SETTING.fieldOptions[GlobalFilterPanelFields.PARAM_COMPANY_ID] = {
    useCompanyCode: true
};

export class DeleteLogFilterPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'Delete log',
                companyId: 1,
                startDate: '',
                endDate: '',
                sortAscending: false
            },
            filterSetting: DEFAULT_FILTER_SETTING
        };
        this.onReportChangeHandler = this.onReportChangeHandler.bind(this);
        this.onCheckboxChangeHandler = this.onCheckboxChangeHandler.bind(this);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    }

    onReportChangeHandler(selection = {}) {
        log.debug('onReportChangeHandler reportType', selection.reportType);
        this.props.onReportTypeChange(selection);
    }

    onCheckboxChangeHandler(evt) {
        let selection = Object.assign({}, this.state.selection);
        selection.sortAscending = !evt.target.checked;
        this.setState({
            selection: selection
        });
    }

    onSearchClickHandler(selection) {
        log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
        log.debug('onSearchClickHandler(): selection: ', selection);
        let existingSelection = Object.assign({}, this.state.selection);
        existingSelection.companyId = selection.companyId;
        existingSelection.startDate = selection.startDate;
        existingSelection.endDate = selection.endDate;
        this.props.onSearchClick(existingSelection);
    }

    render() {
        log.debug('render() - props: ', this.props);
        let selection = this.state.selection || {};
        const filterSetting = this.state.filterSetting || DEFAULT_FILTER_SETTING;

        return (
            <div data-test="component-delete-log-filter-panel">
                <s-box name="filter-panel">
                    <GlobalFilterPanel
                        {...filterSetting}
                        onSearchClick={this.onSearchClickHandler}>

                        <DataMiningCommonFilterPanel
                            reportType={this.state.selection.reportType}
                            onReportTypeChange={this.onReportChangeHandler}
                        />
                        <fieldset>
                            <legend><LanguageStringResolver string='dataMining_InvoiceLines_SortByDate' /></legend>
                            <span className="clear"></span>
                            <input
                                data-test="input-sort-by-date"
                                type="checkbox"
                                onChange={this.onCheckboxChangeHandler}
                                name="deleteLogSortByDate"
                                checked={!selection.sortAscending}
                            />
                            <label className="checkbox">Descending</label>
                        </fieldset>
                    </GlobalFilterPanel>
                    <div className="clear"></div>
                </s-box>
            </div>
        );
    }
}


DeleteLogFilterPanel.defaultProps = {
    onReportTypeChange: () => { },
    onSearchClick: () => { }
}

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    return dispatchProps;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(DeleteLogFilterPanel);